import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { getKeywordsAPI } from "../../api/GetTags";
import Loader from "../mini/Loader";
import { useHistory } from "react-router-dom";
import * as H from "./Home.styled";

const PopularKeywords = () => {
  const history = useHistory();
  const [popularKeywords, setPopularKeywords] = useState([]);

  const { isLoading } = useQuery({
    queryKey: ["GetPopularKeywords"],
    queryFn: () => getKeywordsAPI(),
    select: ({ data }) => data.data.tags,
    onSuccess: (tags) => {
      setPopularKeywords(
        tags.slice(0, 4).sort((a, b) => a.usedCount - b.usedCount)
      );
    },
  });

  const handleSearchKeyword = (word) => {
    history.push(`/search/1/posts/${word.name}/${word.id}`);
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        popularKeywords.length > 0 && (
          <H.HomeSidebarWrapper>
            <H.HomeTitle>Popular Keywords</H.HomeTitle>
            <div className="flex flex-col gap-4">
              {popularKeywords.map((word) => (
                <div
                  key={word.id}
                  onClick={() => handleSearchKeyword(word)}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <p>{word.name}</p>
                </div>
              ))}
            </div>
          </H.HomeSidebarWrapper>
        )
      )}
    </>
  );
};

export default PopularKeywords;
